import {
  CASE_GENERAL_FIELDS,
  CASE_REVIEW_CORRECTION_FIELDS,
  defineAnalysisReviewRules,
  type DefineRule,
  type RuleConditions,
} from "./ability-rule-conditions";

export const defineOperatorRules = (can: DefineRule, conditions: RuleConditions) => {
  can(["create", "read", "viewHistory"], "Case");
  can(
    "update",
    "Case",
    [...CASE_GENERAL_FIELDS, "contacts", "damages", "debt", "paymentPlan"],
    conditions.ownCase,
  );
  can("update", "Case", ["damages", "debt", "paymentPlan"]);
  can("deleteContacts", "Case");
  can("manageNotes", "Case");
  can(["delete", "analyze", "finishOthersDraft"], "Case", conditions.ownCase);
  can(["delete", "analyze", "finishOthersDraft"], "Case", conditions.openCreationReview);
  defineAnalysisReviewRules(can, conditions);
  can("update", "Case", [...CASE_REVIEW_CORRECTION_FIELDS], conditions.assignedAnalysisReview);
  can("manageConversations", "Case");
  can("read", "Client");
  can("readAllBranches", "Client");
  can(
    ["create", "read", "readAll", "update", "assignOnCreate", "updateMetadata", "emailAssignee"],
    "Task",
  );
  can("execute", "Task", conditions.assignedTask);
  can(["createReminder", "updateReminder", "removeReminder"], "Task", conditions.assignedTask);
  can(["create", "update", "delete"], "Document");
  can(["read", "readAnalysis"], "Document", { visibleTo: "Operator" });
  can(["read", "update"], "Profile");
  can("read", "Financial");
  can(["read", "update"], "Notification");
  can(["read", "update"], "UserPreferences");
};
